module.exports = __webpack_public_path__ + "static/img/中小科技企业入库编号.91ded826.png";